import {SleepAsyncUntil, Timer} from "js-vextensions";
import React from "react";
import {BaseComponent} from "react-vextensions";
import {RunInAction_Set, TextSpeaker, UseWindowEventListener} from "web-vcore";
import {store} from "../../../../Store/index.js";
import {PluginGeneral} from "../../../../Utils/Capacitor/GeneralPlugin.js";
import {SetLockOverlayActive} from "../JSessionUI.js";
import {NarrateText} from "../../../../Utils/Services/TTS.js";
import {OverlayPanel} from "../../../../Store/main/tools/journey.js";
import {Vec2} from "../../../../Utils/ThreeJS/VectorStructs.js";

class CurrentDrawData {
	//startTime = Date.now();
	minX: number;
	maxX: number;
	minY: number;
	maxY: number;
	AddPoint(point: Vec2) {
		if (this.minX == null || point.x < this.minX) this.minX = point.x;
		if (this.maxX == null || point.x > this.maxX) this.maxX = point.x;
		if (this.minY == null || point.y < this.minY) this.minY = point.y;
		if (this.maxY == null || point.y > this.maxY) this.maxY = point.y;
	}
}

class PointerDownInfo {
	constructor(public time: number, public pos: Vec2) {}
}

export class CanvasOverlay extends BaseComponent<{}, {drag_downPosX: number|n, drag_lastPosX: number|n}> {
	//static instance = null as CanvasOverlay; // for calling from TestingPanel.tsx
	onWindowResize = ()=>this.Update();
	ComponentWillMount = ()=>{
		SetLockOverlayActive(true);
		//CanvasOverlay.instance = this;
		window.addEventListener("resize", this.onWindowResize);
	};
	ComponentWillUnmount = ()=>{
		SetLockOverlayActive(false);
		//CanvasOverlay.instance = null;
		window.removeEventListener("resize", this.onWindowResize);
	};

	canvas: HTMLCanvasElement;
	ctx: CanvasRenderingContext2D;
	//mouse = new Vec2(0, 0);

	last2PointerDownInfos = [] as PointerDownInfo[];
	pointerDown = false;
	/** Struct accompanying the visual draw-data; when visuals are cleared, this is as well. */
	currentDraw: CurrentDrawData|n;

	render() {
		let {} = this.props;

		// when window-size changes, update canvas size to match it (needed, eg. if nav-button toolbar gets hidden just after overlay closes)
		//UseWindowEventListener("resize", ()=>this.Update());

		return (
			<div
				style={{
					position: "fixed", zIndex: 100,
					left: 0, top: 0, right: 0, bottom: 0,
					//top: 0, bottom: 0, width: window.innerHeight * 2, height: window.innerHeight,
					display: "flex", alignItems: "center", justifyContent: "center",
					background: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(3px)",
				}}
			>
				<canvas width={window.innerWidth * 2} height={window.innerHeight}
					style={{
						touchAction: "none",
						position: "absolute", top: 0, right: 0, width: window.innerWidth * 2, height: window.innerHeight,
					}}
					ref={c=>{
						if (c) {
							this.canvas = c;
							this.ctx = c.getContext("2d")!;
							this.ctx.lineJoin = "round";
							this.ctx.lineCap = "round";
							this.ctx.strokeStyle = "white";
							this.ctx.lineWidth = 10;
						}
					}}
					onPointerMove={e=>{
						const mousePos = new Vec2(e.pageX - this.canvas.offsetLeft, e.pageY - this.canvas.offsetTop);
						if (this.pointerDown) {
							this.ctx.lineTo(mousePos.x, mousePos.y);
							this.ctx.stroke();
							this.currentDraw!.AddPoint(mousePos);
						}
					}}
					onPointerDown={e=>{
						const mousePos = new Vec2(e.pageX - this.canvas.offsetLeft, e.pageY - this.canvas.offsetTop);
						this.last2PointerDownInfos.push(new PointerDownInfo(Date.now(), mousePos));
						while (this.last2PointerDownInfos.length > 2) this.last2PointerDownInfos.splice(0, 1);
						this.pointerDown = true;
						this.currentDraw = this.currentDraw ?? new CurrentDrawData();
						this.currentDraw.AddPoint(mousePos);

						this.ctx.beginPath();
						this.ctx.moveTo(mousePos.x, mousePos.y);

						this.lastSubmittedIDThatsStillValid = null;
						//this.submitTimer.Stop();
						this.clearCurrentDrawTimer.Stop();
					}}
					onPointerUp={e=>{
						const mousePos = new Vec2(e.pageX - this.canvas.offsetLeft, e.pageY - this.canvas.offsetTop);
						this.FinalizeCanvasAndAcquireCandidateChar(this.currentDraw!);
						this.pointerDown = false;
						this.clearCurrentDrawTimer.Start();

						if (this.last2PointerDownInfos.length == 2 && Date.now() - this.last2PointerDownInfos[0].time < 500) {
							const maxMouseDist = Math.max(
								this.last2PointerDownInfos[0].pos.DistanceTo(this.last2PointerDownInfos[1].pos),
								this.last2PointerDownInfos[0].pos.DistanceTo(mousePos),
								this.last2PointerDownInfos[1].pos.DistanceTo(mousePos),
							);
							if (maxMouseDist < 50) {
								this.OnDoubleClick();
							}
						}
					}}/>
			</div>
		);
	}

	clearCurrentDrawTimer = new Timer(1000, ()=>{
		this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
		this.pointerDown = false; // even if pointer is still down, we want to stop drawing
		this.currentDraw = null;
	}, 1);

	FinalizeCanvasAndAcquireCandidateChar(drawData: CurrentDrawData) {
		//const ctx = this.ctx;
		// create copy of canvas, to draw extra "A" character onto
		var newCanvas = document.createElement("canvas");
		var ctx = newCanvas.getContext("2d")!;
		newCanvas.width = this.canvas.width;
		newCanvas.height = this.canvas.height;
		ctx.drawImage(this.canvas, 0, 0);

		// add an "A" character to left of rect-area that user drew in
		ctx.fillStyle = "white";
		const ySize = drawData.maxY - drawData.minY;
		//this.ctx.font = `${ySize * 1.2}px Arial`;
		ctx.font = `${ySize * 1.5}px Quicksand, Roboto, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif`;
		ctx.textAlign = "right";
		ctx.textBaseline = "middle";
		const textRight = drawData.minX - 70;
		ctx.fillText("A", textRight, (drawData.minY + drawData.maxY) / 2);

		/*this.SubmitCanvasToOCR(this.canvas);
		if (InAndroid(false)) this.ctx.clearRect(0, 0, textRight, this.canvas.height);*/
		this.AcquireCandidateCharUsingOCR(newCanvas, drawData);
	}
	lastSubmittedIDThatsStillValid: number|n = -1;
	async AcquireCandidateCharUsingOCR(canvas: HTMLCanvasElement, drawData: CurrentDrawData) {
		const callIDAndStartTime = Date.now();
		this.lastSubmittedIDThatsStillValid = callIDAndStartTime;

		// convert canvas to image
		const imageAsPNG = canvas.toDataURL("image/png");
		//const imageAsBlob = dataURItoBlob(imageAsPNG);
		//const imageAsFile = new File([imageAsBlob], "image.png", {type: "image/png"});

		//const text = (await nativeBridge.Call("ImageToText", imageAsPNG)) as string;
		const {text} = await PluginGeneral.ImageToText({imageData: imageAsPNG});
		await SleepAsyncUntil(callIDAndStartTime + 300);
		// if another OCR request was made (OR if the pointer was downed) since this call's start, ignore cancel this OCR call
		if (this.lastSubmittedIDThatsStillValid != callIDAndStartTime) return;

		//const chars = text.split("");
		//const chars = text.split("").Exclude({excludeEachOnlyOnce: false}, "a", "A");
		//const chars = text.split("").slice(1); // exclude the first "A", since it was auto-generated (as helper for OCR)
		//const chars = text.toLowerCase().split("").Exclude({excludeEachOnlyOnce: true}, "a");
		const chars = text.split("").Exclude({excludeEachOnlyOnce: true}, "A");
		const validChars = chars.filter(ch=>ch.match(/^[a-zA-Z0-9<>]$/) != null);
		const finalChars = validChars
			// for now, just always lowercase the letters (consistency; some letters are drawn as uppercase, but result should be consistent)
			.map(ch=>ch.toLowerCase())
			// for hyphens and spaces, use these special-chars (they're easier to draw/recognize)
			.map(ch=>{
				if (ch == "<") return "-";
				if (ch == ">") return " ";
				return ch;
			});
		const finalCharsAsString_withCommas = finalChars.join(", ");

		// special processing (before regular char-submission)
		let closedOverlay = false;
		{
			// probably temp
			if (finalCharsAsString_withCommas.toLowerCase() == "x, r") {
				RunInAction_Set(()=>store.main.engine.journey.overlay = OverlayPanel.none);
				closedOverlay = true;
			}
			// maybe temp
			if (chars.length == 0 && drawData.maxX - drawData.minX >= window.innerWidth * .8 && drawData.maxY - drawData.minY >= window.innerHeight * .8) {
				RunInAction_Set(()=>store.main.engine.journey.overlay = OverlayPanel.none);
				closedOverlay = true;
			}
		}

		//NarrateText(charsAsString_withCommas, ocrTextSpeaker);
		const finalCharSelection = finalChars[0];
		if (finalCharSelection == null) {
			if (closedOverlay) NarrateText({text: "closed overlay", textSpeaker: ocrTextSpeaker});
			return;
		}

		const finalCharSelection_textForSpeech =
			finalCharSelection == "-" ? "hyphen" :
			finalCharSelection == " " ? "space" :
			finalCharSelection;
		NarrateText({text: finalCharSelection_textForSpeech + (closedOverlay ? ", closed overlay" : ""), textSpeaker: ocrTextSpeaker});
		this.candidateChar = finalCharSelection;
	}

	candidateChar: string|n;
	OnDoubleClick() {
		CanvasOverlay_OnDoubleClick(this.candidateChar);
		this.candidateChar = null;
	}
}
const ocrTextSpeaker = new TextSpeaker();

// todo: needs updating to work with entitySequence->shortText change
export function CanvasOverlay_OnDoubleClick(candidateChar: string|n) {
	// if candidateChar is null, or isn't a valid search-character (since search uses simplification), return
	/*if (candidateChar == null || LowercaseAndSimplifyTextForSearch(candidateChar).length == 0) return;
	if (liveFBASession == null) return;
	const journeyComp = liveFBASession.Comp(AlarmsComp);
	if (journeyComp.inputMode != JourneyInputMode.Entry) return;

	const entryComp = liveFBASession.Comp(JourneyEntryComp);
	let prefixTextToSpeak = "";
	if (!entryComp.searchingEntity) {
		entryComp.searchingEntity = true;
		//prefixTextToSpeak = "Starting search. ";
		prefixTextToSpeak = "Searching. ";
	}

	const uiState = store.main.engine.journey.entities;
	if (uiState.searchText.length == 0) uiState.searchText = "^";
	uiState.searchText += candidateChar;
	entryComp.search_entityIndex = 0;
	entryComp.Search_SpeakCurrentEntity(prefixTextToSpeak);*/
}